import useSelector from '@app/hooks/useSelector';
import { getProjectRights } from '@app/selectors';

import {
    getAvailableProjects,
    getDownload,
    getExportConfig,
    getIndentationDefaults,
    getPlaceholderFormatDefaults,
    getPluralFormatDefaults,
    getProjectId,
    getProjectType,
} from '../../reducers/downloadData/selectors';
import { getDownloadExportLoading } from '../../reducers/downloadExport/selectors';
import DownloadPage from './DownloadPage';

const DownloadPageContainer = () => {
    const download = useSelector(getDownload);
    const exportConfig = useSelector(getExportConfig);
    const placeholderFormatDefaults = useSelector(getPlaceholderFormatDefaults);
    const pluralFormatDefaults = useSelector(getPluralFormatDefaults);
    const indentationDefaults = useSelector(getIndentationDefaults);
    const projectType = useSelector(getProjectType);
    const availableProjects = useSelector(getAvailableProjects);
    const projectId = useSelector(getProjectId);
    const loading = useSelector(getDownloadExportLoading);
    const { settings } = useSelector(getProjectRights);

    if (
        !(
            download &&
            exportConfig &&
            placeholderFormatDefaults &&
            pluralFormatDefaults &&
            indentationDefaults &&
            projectType &&
            availableProjects &&
            projectId
        )
    ) {
        return null;
    }

    return (
        <DownloadPage
            exportConfig={exportConfig}
            placeholderFormatDefaults={placeholderFormatDefaults}
            pluralFormatDefaults={pluralFormatDefaults}
            indentationDefaults={indentationDefaults}
            projectType={projectType}
            availableProjects={availableProjects}
            loading={loading}
            projectId={projectId}
            settingsPermissionsEnabled={settings}
        />
    );
};

export default DownloadPageContainer;
